{
  "fallbackName": "Bénévole",
  "details": "Détails",
  "retry": "Réessayer",
  "assignedHeading": "Formations assignées",
  "assignTraining": "Assigner une formation",
  "emptyTitle": "Aucune formation assignée",
  "emptyMessage": "Aucun module de formation n'a encore été assigné à {{person}}.",
  "anotherTeam": "Une autre équipe",
  "unavailableModule": "Module indisponible",
  "moduleUnavailable": "Ce module de formation n'est plus disponible.",
  "completed": "Terminé",
  "lessonsComplete_one": "{{count}} leçon terminée",
  "lessonsComplete_other": "{{count}} leçons terminées",
  "notStarted": "Pas commencé",
  "due": "À faire d'ici le {{date}}",
  "overdue": "En retard depuis le {{date}}",
  "via": "via {{team}}"
}
